import React, { useEffect, useState } from"react";
import axios from"axios";
import API_BASE_URL from"../Config/config";
import {
 Button,
 Select,
 MenuItem,
 Table,
 TableHead,
 TableRow,
 TableCell,
 TableBody,
 Typography,
 Box,
 FormControl,
 InputLabel,
} from"@mui/material";

const SupportTicketDashboard = () => {
 const [tickets, setTickets] = useState([]);
 const [statusUpdate, setStatusUpdate] = useState({});
 const [loading, setLoading] = useState(true);
 const [categoryFilter, setCategoryFilter] = useState("");
 const [statusFilter, setStatusFilter] = useState("");
 const [userTypeFilter, setUserTypeFilter] = useState("");

 const fetchTickets = async () => {
 try {
 setLoading(true);
 const res = await axios.get(`${API_BASE_URL}/api/support`);
 console.log("Fetched tickets:", res.data);
 if (res.data && Array.isArray(res.data)) {
 setTickets(res.data);
 } else {
 console.error("Invalid ticket data format:", res.data);
 setTickets([]);
 }
 setLoading(false);
 } catch (error) {
 console.error("Error fetching tickets:", error);
 alert(`Failed to load tickets: ${error.response?.data?.error || error.message}`);
 setTickets([]);
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchTickets();
 }, []);

 const handleStatusChange = (id, newStatus) => {
 setStatusUpdate({ ...statusUpdate, [id]: newStatus });
 };

 const updateStatus = async (id) => {
 try {
 const status = statusUpdate[id];
 await axios.put(`${API_BASE_URL}/api/support/${id}`, { status });
 fetchTickets();
 } catch (error) {
 console.error("Error updating status:", error);
 }
 };

 // ✅ Apply category, status, and user_type filters
 const filteredTickets = tickets.filter((ticket) => {
 const categoryMatch = categoryFilter ? ticket.category === categoryFilter : true;
 const statusMatch = statusFilter ? ticket.status === statusFilter : true;
 const userTypeMatch = userTypeFilter ? ticket.user_type === userTypeFilter : true;
 return categoryMatch && statusMatch && userTypeMatch;
 });

 return (
 <Box sx={{ minHeight:"100vh", backgroundColor:"brand.midnight", color:"#fff", p: 5, background:"radial-gradient(circle at center, #0F172A 0%, #020617 100%)" }}>
 <Typography variant="h4" gutterBottom sx={{ color:"var(--primary-blue, #4F46E5)", mb: 4, fontWeight:"extrabold", textTransform:"uppercase", letterSpacing: 1 }}>
 Support <span style={{ color:"#7C3AED" }}>Ticket</span> Dashboard
 </Typography>

 {/* Filter Controls */}
 <Box sx={{ display:"flex", gap: 3, mb: 6, flexWrap:"wrap" }}>
 {/* Category Filter */}
 <FormControl variant="outlined" sx={{ minWidth: 220 }}>
 <InputLabel sx={{ color:"#64748B" }}>Category</InputLabel>
 <Select
 value={categoryFilter}
 onChange={(e) => setCategoryFilter(e.target.value)}
 label="Category"
 sx={{
 backgroundColor:"rgba(2, 6, 23, 0.5)",
 color:"#fff",
 borderRadius: 3,
"& fieldset": { borderColor:"rgba(255, 255, 255, 0.1)" },
"& .MuiSelect-icon": { color:"#22D3EE" },
 }}
 >
 <MenuItem value="">All Categories</MenuItem>
 <MenuItem value="Bug">🪲 Bug</MenuItem>
 <MenuItem value="Feedback">💬 Feedback</MenuItem>
 <MenuItem value="Billing">💰 Billing</MenuItem>
 <MenuItem value="Other">❓ Other</MenuItem>
 </Select>
 </FormControl>

 {/* Status Filter */}
 <FormControl variant="outlined" sx={{ minWidth: 220 }}>
 <InputLabel sx={{ color:"#64748B" }}>Status</InputLabel>
 <Select
 value={statusFilter}
 onChange={(e) => setStatusFilter(e.target.value)}
 label="Status"
 sx={{
 backgroundColor:"rgba(2, 6, 23, 0.5)",
 color:"#fff",
 borderRadius: 3,
"& fieldset": { borderColor:"rgba(255, 255, 255, 0.1)" },
"& .MuiSelect-icon": { color:"#22D3EE" },
 }}
 >
 <MenuItem value="">All</MenuItem>
 <MenuItem value="open">Open</MenuItem>
 <MenuItem value="inprogress">In Progress</MenuItem>
 <MenuItem value="closed">Closed</MenuItem>
 </Select>
 </FormControl>

 {/* User Type Filter */}
 <FormControl variant="outlined" sx={{ minWidth: 220 }}>
 <InputLabel sx={{ color:"#64748B" }}>User Type</InputLabel>
 <Select
 value={userTypeFilter}
 onChange={(e) => setUserTypeFilter(e.target.value)}
 label="User Type"
 sx={{
 backgroundColor:"rgba(2, 6, 23, 0.5)",
 color:"#fff",
 borderRadius: 3,
"& fieldset": { borderColor:"rgba(255, 255, 255, 0.1)" },
"& .MuiSelect-icon": { color:"#22D3EE" },
 }}
 >
 <MenuItem value="">All Users</MenuItem>
 <MenuItem value="student">Student</MenuItem>
 <MenuItem value="college">College</MenuItem>
 </Select>
 </FormControl>
 </Box>

 {/* Glowing Table Box */}
 <Box
 sx={{
 borderRadius: 4,
 boxShadow:"0 0 40px rgba(37, 99, 235, 0.15)",
 overflowX:"auto",
 border:"1px solid rgba(255, 255, 255, 0.05)",
 backgroundColor:"#0F172A",
 }}
 >
 {loading ? (
 <Box sx={{ p: 8, textAlign:"center" }}>
 <Typography sx={{ color:"#22D3EE", animate:"pulse" }}>Syncing with support server...</Typography>
 </Box>
 ) : filteredTickets.length === 0 ? (
 <Typography sx={{ p: 8, textAlign:"center", color:"#94a3b8" }}>
 {tickets.length === 0 ?"No tickets found. Tickets will appear here once users submit support requests." :"No tickets match the selected filters."}
 </Typography>
 ) : (
 <Table sx={{ backgroundColor:"transparent" }}>
 <TableHead>
 <TableRow sx={{ backgroundColor:"rgba(37, 99, 235, 0.1)" }}>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>ID</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>User Email</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>User Type</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>Category</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>Message</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>Status</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>Created At</TableCell>
 <TableCell sx={{ color:"#22D3EE", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.1)" }}>Actions</TableCell>
 </TableRow>
 </TableHead>
 <TableBody>
 {[...filteredTickets].sort((a, b) => (b.id || 0) - (a.id || 0)).map((ticket) => (
 <TableRow key={ticket.id} sx={{"&:hover": { backgroundColor:"rgba(255, 255, 255, 0.02)" } }}>
 <TableCell sx={{ color:"#94a3b8", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>{ticket.id}</TableCell>
 <TableCell sx={{ color:"#fff", fontWeight:"bold", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>{ticket.user_email}</TableCell>
 <TableCell sx={{ color:"#cbd5e1", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>
 <span style={{ 
 padding:"2px 8px", 
 borderRadius:"4px", 
 fontSize:"11px", 
 fontWeight:"bold", 
 textTransform:"uppercase",
 backgroundColor: ticket.user_type === 'college' ?"rgba(124, 58, 237, 0.2)" :"rgba(37, 99, 235, 0.2)",
 color: ticket.user_type === 'college' ?"#A78BFA" :"#60A5FA"
 }}>
 {ticket.user_type}
 </span>
 </TableCell>
 <TableCell sx={{ color:"#cbd5e1", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>{ticket.category}</TableCell>
 <TableCell sx={{ color:"#94a3b8", maxWidth:"300px", wordBreak:"break-word", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>{ticket.message}</TableCell>
 <TableCell sx={{ borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>
 <span style={{ 
 padding:"2px 8px", 
 borderRadius:"12px", 
 fontSize:"11px", 
 fontWeight:"bold", 
 textTransform:"capitalize",
 backgroundColor: ticket.status === 'closed' ?"rgba(16, 185, 129, 0.2)" : ticket.status === 'inprogress' ?"rgba(245, 158, 11, 0.2)" :"rgba(239, 68, 68, 0.2)",
 color: ticket.status === 'closed' ?"#10B981" : ticket.status === 'inprogress' ?"#F59E0B" :"#EF4444"
 }}>
 {ticket.status ||"open"}
 </span>
 </TableCell>
 <TableCell sx={{ color:"#cbd5e1", borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>
 {ticket.created_at ? new Date(ticket.created_at).toLocaleDateString() :"N/A"}
 </TableCell>
 <TableCell sx={{ borderBottom:"1px solid rgba(255, 255, 255, 0.05)" }}>
 <Box sx={{ display: 'flex', gap: 1 }}>
 <Select
 value={statusUpdate[ticket.id] || ticket.status}
 onChange={(e) => handleStatusChange(ticket.id, e.target.value)}
 size="small"
 sx={{
 backgroundColor:"rgba(2, 6, 23, 0.5)",
 color:"#fff",
 borderRadius: 2,
 fontSize:"0.75rem",
"& .MuiSelect-icon": { color:"#22D3EE" },
 }}
 >
 <MenuItem value="open">Open</MenuItem>
 <MenuItem value="inprogress">In Progress</MenuItem>
 <MenuItem value="closed">Closed</MenuItem>
 </Select>
 <Button
 variant="contained"
 onClick={() => updateStatus(ticket.id)}
 sx={{ 
 background:"linear-gradient(90deg, var(--primary-blue, #4F46E5), #7C3AED)", 
 color:"#fff", 
 fontWeight:"bold",
 borderRadius: 2,
 px: 2,
 textTransform:"none",
"&:hover": { opacity: 0.9 }
 }}
 >
 Update
 </Button>
 </Box>
 </TableCell>
 </TableRow>
 ))}
 </TableBody>
 </Table>
 )}
 </Box>
 </Box>
 );
};

export default SupportTicketDashboard;




